import React from 'react';

import HeaderDesktop from './desktop';
import HeaderMobile from './mobile';

const Header = React.memo(({ width, ...rest }) =>
  width > 767 ? <HeaderDesktop {...rest} /> : <HeaderMobile {...rest} />
);

export default Header;
